/* ============================================================
   WeLume 彫刻シミュレーター（1列/2列 対応）
   入力値は textContent でのみ描画（XSS対策）。外部送信・保存なし。
   ・書体：Lato / Dancing Script
   ・列数：1列 or 2列（2列は上段・下段の2行）
   ・各行が彫刻幅に収まるか個別に判定し、超過分は自動でカット
   ============================================================ */
(function () {
  'use strict';

  function initBlock(root) {
    if (root.dataset.wlInit) return;
    root.dataset.wlInit = '1';

    /* ====== SETTINGS ====== */
    var SETTINGS = {
      REFERENCE_STRINGS: ['Yuki & Ren', '2026.06.25'], // 上限の基準（両書体で実測し最大幅を採用）
      SAFETY_FACTOR: 1.00,   // 上限の余裕。1.10で+10%緩める／0.95で5%厳しく
      BASE_FONT_PX: 56,      // 測定・表示の基準フォントサイズ(px)
      WARN_RATIO: 0.85       // この割合超で「ぎりぎり」表示
    };
    /* ====================== */

    var tabs = root.querySelectorAll('.wl-tab');
    var rowBtns = root.querySelectorAll('.wl-row-btn');
    var inputs = [root.querySelector('.wl-input-1'), root.querySelector('.wl-input-2')];
    var fields = [root.querySelector('.wl-field-1'), root.querySelector('.wl-field-2')];
    var ptexts = [root.querySelector('.wl-plate-text-1'), root.querySelector('.wl-plate-text-2')];
    var alertB = root.querySelector('.wl-alert');
    var plate = root.querySelector('.wl-plate');
    var cap = root.querySelector('.wl-plate-cap');
    var fill = root.querySelector('.wl-gauge-fill');
    var mline = root.querySelector('.wl-measure-line');

    // 測定用の隠し要素は JS 側で生成（HTMLから消えても確実に存在させる）
    var meas = root.querySelector('.wl-measure');
    if (!meas) {
      meas = document.createElement('span');
      meas.className = 'wl-measure';
      meas.setAttribute('aria-hidden', 'true');
      meas.style.position = 'absolute';
      meas.style.visibility = 'hidden';
      meas.style.whiteSpace = 'nowrap';
      meas.style.left = '-9999px';
      meas.style.top = '0';
      meas.style.pointerEvents = 'none';
      root.appendChild(meas);
    }

    // 必須要素が欠けていたら安全に中断
    if (!inputs[0] || !plate || !ptexts[0] || !fill) {
      return;
    }

    var alertTimer = null;
    var rows = parseInt(root.getAttribute('data-rows'), 10) === 2 ? 2 : 1;

    function fontStack(f) {
      return f === 'script' ? "'Dancing Script','Lato',cursive" : "'Lato',sans-serif";
    }
    function currentFont() {
      return root.getAttribute('data-font') === 'script' ? 'script' : 'sans';
    }

    function measureWidth(str, f) {
      meas.style.fontFamily = fontStack(f);
      meas.style.fontSize = SETTINGS.BASE_FONT_PX + 'px';
      meas.textContent = str;
      return meas.getBoundingClientRect().width;
    }

    function computeMaxWidth() {
      var max = 0;
      var fonts = ['sans', 'script'];
      for (var i = 0; i < fonts.length; i++) {
        for (var j = 0; j < SETTINGS.REFERENCE_STRINGS.length; j++) {
          var w = measureWidth(SETTINGS.REFERENCE_STRINGS[j], fonts[i]);
          if (w > max) max = w;
        }
      }
      return max * SETTINGS.SAFETY_FACTOR;
    }
    var MAX_WIDTH_PX = computeMaxWidth();

    function flashAlert(input) {
      if (alertB) {
        alertB.classList.add('is-show');
        if (alertTimer) clearTimeout(alertTimer);
        alertTimer = setTimeout(function () {
          alertB.classList.remove('is-show');
          for (var k = 0; k < inputs.length; k++) {
            if (inputs[k]) inputs[k].classList.remove('is-limit');
          }
        }, 1600);
      }
      if (input) input.classList.add('is-limit');
    }

    function clampToWidth(str, f) {
      if (measureWidth(str, f) <= MAX_WIDTH_PX) return str;
      var lo = 0;
      var hi = str.length;
      var fit = '';
      while (lo <= hi) {
        var mid = Math.floor((lo + hi) / 2);
        var sub = str.slice(0, mid);
        if (measureWidth(sub, f) <= MAX_WIDTH_PX) {
          fit = sub;
          lo = mid + 1;
        } else {
          hi = mid - 1;
        }
      }
      return fit;
    }

    // 1つの入力欄について、幅を超えていたら収まる範囲まで削って返す
    function enforceLimit(input) {
      var f = currentFont();
      var v = input.value;
      if (measureWidth(v, f) <= MAX_WIDTH_PX) return v;
      var clamped = clampToWidth(v, f);
      var pos = clamped.length;
      input.value = clamped;
      try { input.setSelectionRange(pos, pos); } catch (e) {}
      flashAlert(input);
      return clamped;
    }

    function render() {
      var f = currentFont();

      // チャーム（円形）の表示サイズはCSSが決める。未レイアウト時はビューポートから概算
      var diameter = plate.clientWidth;
      if (!diameter || diameter < 140) diameter = Math.min(300, Math.round((window.innerWidth || 375) * 0.76));

      // 各行の値（幅制限を適用）
      var vals = [];
      for (var a = 0; a < rows; a++) vals[a] = enforceLimit(inputs[a]);

      // 表示フォント：各行を独立に、その行が最大幅いっぱいになるよう拡大（1行目は2行目に影響されない）
      var usableW = diameter * 0.86;
      var capFont = rows === 2 ? diameter * 0.28 : diameter * 0.54;

      if (cap) cap.innerHTML = (rows === 2
        ? '彫刻イメージ（上段・下段がこの範囲に収まる長さまで）'
        : '彫刻イメージ（この範囲に収まる長さまで）')
        + '<br>表示は仕上がりのイメージです。実物とは文字の大きさやバランスが多少異なる場合がございます';

      var maxRatio = 0;
      var anyText = false;

      for (var i = 0; i < 2; i++) {
        var active = i < rows;
        if (fields[i]) fields[i].hidden = !active;
        if (ptexts[i]) ptexts[i].hidden = !active;
        if (!active) continue;

        var v = vals[i];
        var hasText = v.length > 0;
        if (hasText) anyText = true;

        ptexts[i].style.fontFamily = fontStack(f);
        if (hasText) {
          var w0 = measureWidth(v, f);
          ptexts[i].style.fontSize = (w0 > 0 ? Math.min(SETTINGS.BASE_FONT_PX * usableW / w0, capFont) : capFont) + 'px';
          ptexts[i].textContent = v;
          ptexts[i].classList.remove('wl-empty');
        } else {
          ptexts[i].style.fontSize = '14px';
          ptexts[i].textContent = rows === 2 ? (i === 0 ? '上段' : '下段') : 'ここに文字が刻まれます';
          ptexts[i].classList.add('wl-empty');
        }

        var w = hasText ? measureWidth(v, f) : 0;
        var ratio = MAX_WIDTH_PX > 0 ? w / MAX_WIDTH_PX : 0;
        if (ratio > maxRatio) maxRatio = ratio;
      }

      fill.style.width = Math.min(maxRatio, 1) * 100 + '%';
      plate.classList.remove('is-near');

      if (!anyText) {
        fill.style.background = 'var(--wl-line)';
        if (mline) mline.textContent = '';
      } else if (maxRatio <= SETTINGS.WARN_RATIO) {
        fill.style.background = 'var(--wl-ok)';
        if (mline) mline.textContent = '彫刻できます（余裕があります）';
      } else {
        fill.style.background = 'var(--wl-warn)';
        plate.classList.add('is-near');
        if (mline) mline.textContent = 'ぎりぎりです。これ以上は入力できません。';
      }
    }

    // 書体タブ
    for (var t = 0; t < tabs.length; t++) {
      (function (tab) {
        tab.addEventListener('click', function () {
          for (var k = 0; k < tabs.length; k++) tabs[k].setAttribute('aria-selected', 'false');
          tab.setAttribute('aria-selected', 'true');
          root.setAttribute('data-font', tab.getAttribute('data-font') === 'script' ? 'script' : 'sans');
          render();
        });
      })(tabs[t]);
    }

    // 列数切替（1列 / 2列）
    for (var r = 0; r < rowBtns.length; r++) {
      (function (btn) {
        btn.addEventListener('click', function () {
          rows = parseInt(btn.getAttribute('data-rows'), 10) === 2 ? 2 : 1;
          root.setAttribute('data-rows', String(rows));
          for (var k = 0; k < rowBtns.length; k++) {
            rowBtns[k].setAttribute('aria-pressed', rowBtns[k] === btn ? 'true' : 'false');
          }
          render();
        });
      })(rowBtns[r]);
    }

    // 入力（両行とも）
    for (var m = 0; m < inputs.length; m++) {
      if (!inputs[m]) continue;
      inputs[m].addEventListener('input', render);
      inputs[m].addEventListener('compositionend', render);
      inputs[m].addEventListener('keyup', render);
    }

    render();
    // レイアウト確定後にもう一度（初回は plate 幅が未確定で文字が小さくなるのを防ぐ）
    if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(render); });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        MAX_WIDTH_PX = computeMaxWidth();
        render();
      });
    }
    window.addEventListener('resize', render);
  }

  function initAll() {
    var blocks = document.querySelectorAll('.welume-specimen');
    for (var i = 0; i < blocks.length; i++) initBlock(blocks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
